var map = {
	"./cadastrar-paciente/cadastrar-paciente.module.ts.ngfactory": [
		"./src/$$_gendir/app/paciente/cadastrar-paciente/cadastrar-paciente.module.ngfactory.ts",
		"common",
		"cadastrar-paciente.module"
	],
	"./cadastrar/cadastrar.module.ts.ngfactory": [
		"./src/$$_gendir/app/dietas/cadastrar/cadastrar.module.ngfactory.ts",
		"cadastrar.module"
	],
	"./editar/editar.module.ts.ngfactory": [
		"./src/$$_gendir/app/paciente/editar/editar.module.ngfactory.ts",
		"common",
		"editar.module"
	],
	"app/altera-senha/altera-senha.module.ts.ngfactory": [
		"./src/$$_gendir/app/altera-senha/altera-senha.module.ngfactory.ts",
		"altera-senha.module"
	],
	"app/dietas/dietas.module.ts.ngfactory": [
		"./src/$$_gendir/app/dietas/dietas.module.ngfactory.ts",
		"dietas.module"
	],
	"app/paciente/paciente.module.ts.ngfactory": [
		"./src/$$_gendir/app/paciente/paciente.module.ngfactory.ts",
		"common",
		"paciente.module"
	],
	"app/pacientes/pacientes.module.ts.ngfactory": [
		"./src/$$_gendir/app/pacientes/pacientes.module.ngfactory.ts",
		"common",
		"pacientes.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_gendir lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_gendir lazy
// module id = ./src/$$_gendir lazy recursive
// module chunks = main